import React, { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

// import { tableChangeLoading } from 'modules/filter';
import { makeHeadData } from 'lib/commonLib';
import { IpBlockListDetail } from 'lib/api/server';
import { showSuccessSnackbar } from 'modules/snackbar';

import NewInput from 'components/atoms/NewInput';
import CurrentStatus from 'components/atoms/CurrentStatus';
import NewRadioGroup from 'components/molecules/NewRadioGroup';
import NewTableContainer from 'components/molecules/NewTable';
import Modal from 'components/organisms/NewModal';

const IpBlockModal = (props) => {
  const dispatch = useDispatch();
  const {
    modal,
    handleClose,
    categorySeleteList,
    handleModalValue,
    handleSubmit,
    error,
  } = props;
  const { open, params, type, rowObj } = modal;
  const { t } = useTranslation();
  const [ip, setIp] = useState('');
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState('');

  let tableHeadList = [
    {
      id: 'NO',
      label: 'no',
      orderFlag: false,
      type: 'string',
      format: '@',
      displayFlag: true,
    },
    {
      id: 'REG_DTTM',
      label: t('차단일시'),
      orderFlag: false,
      type: 'string',
      format: '@',
      displayFlag: true,
    },
  ];

  useEffect(() => {
    if (type === 'log' && open) {
      setIp('');
      setList([]);
      setLoading(true);
      getData();
    } else {
      setTimeout(() => {
        setState('');
        setLoading(false);
      }, 200);
    }
    // eslint-disable-next-line
  }, [open]);

  const getData = () => {
    let newParams = {
      limit: 50,
      type: 'log',
      intrcpTp: rowObj['INTRCP_TP'],
      hIntrcpIp: rowObj['H_INTRCP_IP'],
      userUnqKey: rowObj['USER_UNQ_KEY'],
    };
    setLoading(true);
    IpBlockListDetail({ ...newParams })
      .then((response) => {
        const { data } = response.data;
        setIp(data.ip);
        if (data.list.length > 0) {
          setList(data.list);
          setState('');
        } else {
          setState('noData');
        }
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: {
            type: 'error',
          },
        });
      })
      .finally(() => {
        setLoading(false);
        // dispatch(tableChangeLoading(false));
      });
  };

  /**
   * 스낵바 리덕스 값을 변경해주는 함수
   * @type {(...args: any[]) => any}
   */
  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <Modal
        open={open}
        headerTitle={
          loading
            ? undefined
            : type === 'add'
            ? t('차단 IP 등록')
            : type === 'log'
            ? t('차단') + 'IP: ' + ip
            : type === 'upLoad'
            ? t('다중 등록')
            : 'else'
        }
        confirmBtnTitle={
          type === 'upLoad'
            ? t('등록')
            : type === 'delete'
            ? t('삭제')
            : undefined
        }
        cancelBtnTitle={type === 'log' ? t('확인') : undefined}
        confirmBtnOpen={type !== 'log'}
        handleClose={handleClose}
        confirmOnClick={handleSubmit}
        headerOpen={type === 'delete' ? false : undefined}
        useForm={type === 'add'}
        style={
          type === 'upLoad' || type === 'delete' ? undefined : { minWidth: 600 }
        }
      >
        {loading ? (
          <CurrentStatus />
        ) : state === 'noData' ? (
          <CurrentStatus type="noData" />
        ) : state === 'error' ? (
          'error'
        ) : (
          <>
            {type === 'add' && (
              <>
                <tr>
                  <th>{t('카테고리')}</th>
                  <td>
                    <NewRadioGroup
                      params={params}
                      labelKey="CODE_VAL"
                      valueKey="CODE_ID"
                      optionList={categorySeleteList}
                      handleGetValue={handleModalValue}
                      name="intrcpTp"
                      style={{ height: 30 }}
                    />
                  </td>
                </tr>
                <tr>
                  <th>{t('차단 IP')}</th>
                  <td>
                    <NewInput
                      name="intrcpIp"
                      value={params.intrcpIp}
                      params={params}
                      callBack={handleModalValue}
                      error={error.intrcpIp}
                    />
                  </td>
                </tr>
                <tr>
                  <th>{t('비고')}</th>
                  <td>
                    <NewInput
                      name="intrcpRsn"
                      value={params.intrcpRsn}
                      params={params}
                      callBack={handleModalValue}
                      error={error.intrcpRsn}
                    />
                  </td>
                </tr>
              </>
            )}
            {type === 'log' && (
              <NewTableContainer
                params={{
                  sort: 'desc',
                  order: 'REG_DTTM',
                }}
                getParam={(f) => f}
                loading={loading}
                useFetch={false}
                useSearch={false}
                useTotal={false}
                useExcel={false}
                useFullScreen={false}
                propsList={list}
                propsHeadCells={makeHeadData(tableHeadList)}
                useCustomTable
              />
            )}
            {type === 'delete' &&
              rowObj['INTRCP_IP'] + t('를 해제 하시겠습니까?')}
          </>
        )}
      </Modal>
    </>
  );
};

IpBlockModal.propTypes = {
  handleToggleModal: PropTypes.func,
  isOpen: PropTypes.bool,
  params: PropTypes.object,
};

export default IpBlockModal;
